var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.item.hidden
    ? _c(
        "div",
        { staticClass: "menu-wrapper" },
        [
          _vm.hasOneShowingChild(_vm.item.children, _vm.item) &&
          (!_vm.onlyOneChild.children || _vm.onlyOneChild.noShowingChildren) &&
          !_vm.item.alwaysShow
            ? [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      disabled: !_vm.collapse,
                      content: _vm.onlyOneChild.meta.title,
                      effect: "dark",
                      placement: "right",
                    },
                  },
                  [
                    _vm.onlyOneChild.meta
                      ? _c(
                          "app-link",
                          {
                            attrs: {
                              to: _vm.resolvePath(_vm.onlyOneChild.path),
                            },
                          },
                          [
                            _c(
                              "el-menu-item",
                              {
                                class: {
                                  "is-select":
                                    _vm.activeMenu ==
                                    _vm.resolvePath(_vm.onlyOneChild.path),
                                },
                                attrs: {
                                  index: _vm.resolvePath(_vm.onlyOneChild.path),
                                },
                              },
                              [
                                _c("item", {
                                  attrs: {
                                    icon:
                                      _vm.onlyOneChild.meta.icon ||
                                      (_vm.item.meta && _vm.item.meta.icon),
                                    title: _vm.onlyOneChild.meta.title,
                                    num: _vm.onlyOneChild.meta.num,
                                    count: _vm.onlyOneChild.count,
                                    collapse: _vm.collapse,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : _c(
                "el-submenu",
                {
                  ref: "subMenu",
                  class: {
                    "is-select":
                      _vm.activeMenu == _vm.resolvePath(_vm.item.path),
                  },
                  attrs: {
                    index: _vm.resolvePath(_vm.item.path),
                    "popper-append-to-body": "",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _vm.item.meta
                        ? _c("item", {
                            attrs: {
                              icon: _vm.item.meta && _vm.item.meta.icon,
                              title: _vm.item.meta.title,
                              num: _vm.item.meta.num,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.item.children, function (child) {
                    return _c("sidebar-item", {
                      key: child.path,
                      staticClass: "nest-menu",
                      attrs: {
                        "is-nest": true,
                        item: child,
                        "base-path": _vm.resolvePath(child.path),
                        "active-menu": _vm.activeMenu,
                      },
                    })
                  }),
                ],
                2
              ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }